import _reducer from "redux-form/es/reducer";
import thunk from 'redux-thunk';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { browserHistory } from 'react-router';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import { IS_PRODUCTION } from 'swag-common/config/constants';
import popupManagerReducer from 'swag-client-common/redux/popup-manager/popup-manager.reducer';
import notification from 'swag-client-common/redux/notification/notification.reducer';
import { goodieGiveawayReducer } from 'swag-client-common/redux/goodie-giveaway/goodie-giveaway.reducer';
import postponeActions from '../middleware/postpone-actions.middleware';
import { windowManipulationMiddleware } from '../middleware/window-manipulations.middleware';
import { giveawayLandingReducer } from './giveaway-landing/giveaway-landing.reducer';
import { imageLoadingReducer } from './image-loading/image-loading.reducer';
import commonReducer from './common/common.reducer';
const historyMiddleware = routerMiddleware(browserHistory);
const reducers = combineReducers({
  form: _reducer,
  giveawayLanding: giveawayLandingReducer,
  imageLoading: imageLoadingReducer,
  common: commonReducer,
  routing: routerReducer,
  popupManager: popupManagerReducer,
  notification,
  goodieGiveaway: goodieGiveawayReducer
});
const middleware = [thunk, postponeActions, historyMiddleware, windowManipulationMiddleware];
const isEnableReduxCompression = false;
const actionSanitizer = action => action;
const composeEnhancers = !IS_PRODUCTION && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(isEnableReduxCompression ? {
  actionSanitizer,
  stateSanitizer: state => ({
    giveawayLanding: state.giveawayLanding
  })
} : {}) || compose;
export const giveawayStore = createStore(reducers, {}, composeEnhancers(applyMiddleware(...middleware)));